import * as React from 'react';
import { Form, useFormikContext } from 'formik';
import styled from 'styled-components';
import { Panel } from '@rtkwlf/ui';
import { ScannerFormValues } from './constants';
import { ShippingInputs } from '../sensor/form/ShippingInputs';
import { InformationInputs } from '../sensor/form/InformationInputs';
import { Summary } from '../sensor/form/Summary';
import { RouterPrompt } from '../../../../../widgets/RouterPrompt';
import { useBeforeUnloadConfirmation } from '../../../hooks/useBeforeUnloadConfirmation';
import { FooterButtons } from '../../../FooterButtons';
import { IPConfigFormInputs } from '../../forms/IPConfigFormInputs';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const LeftPanel = styled(Panel)`
  width: 700px;
  && {
    margin-left: 0;
    padding: 3rem;
  }
`;

export const FixedRightPanel = styled(Panel)`
  position: fixed;
  && {
    margin-left: 750px;
    padding: 3rem;
  }
  max-width: 470px;
`;

export const PanelTitle = styled.h3`
  margin-bottom: 2rem;
`;

type Props = {
  showSaveAndAdd?: boolean;
  view?: string;
};

export const OnboardingScannerForm: React.FunctionComponent<Props> = ({
  showSaveAndAdd,
  view,
}) => {
  useBeforeUnloadConfirmation();

  const { values } = useFormikContext<ScannerFormValues>();

  // Formik is causing the page to scroll to the bottom on mount for some reason
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Form>
      <RouterPrompt />
      <Container>
        <LeftPanel>
          <InformationInputs deviceType="Scanner" />

          <IPConfigFormInputs />

          <ShippingInputs />
          <FooterButtons showSaveAndAdd={!!showSaveAndAdd} view={view} />
        </LeftPanel>

        <FixedRightPanel>
          <PanelTitle>Summary</PanelTitle>
          <Summary
            device={values}
            isInfoSet={!!(values.model && values.name)}
          />
        </FixedRightPanel>
      </Container>
    </Form>
  );
};
